<template>
<div>

  <!-- SIDE BAR SECTION -->
  <div class="fixed z-50">
      <sideBar/>
    </div>


  <nav class="sticky w-full z-40 top-0 " >

        <navBar/>

  </nav>


  

<!-- DASHBOARD -->

<div class="flex flex-col bg-[#e8e6fe] w-full pb-12 h-full relative">



  <div class="flex">

  
    <!-- REMINDER PAGE CONTENT -->

  <div class=" mt-2 w-full mx-10 ml-72">

     <!-- Search and Add Reminder -->
    <div class="flex justify-between w-full"> 
            <div class=" flex  text-left font-medium text-lg mb-3 w-4/6 ">
                <form action="" @keyup="searchReminder" class="flex align-middle content-center text-center w-full">
                  <i class="ri-search-line text-xl text-gray-500 absolute ml-5 mt-2"></i>
                    <input type="search" v-model="searchInput" class=" py-2.5 px-20 w-full  rounded-xl  placeholder:text-sm font-euclid font-normal" placeholder="Enter Phone number">
                </form>
            </div>
      
            <div v-if="!verifyStatus" class="text-white w-2/6  font-euclid font-semibold text-base">
            <button @click="unverifyAlert" class="py-2 px-4 bg-gray-400 rounded-xl">Add Reminder</button>
            </div>

            <div v-else class="text-white  font-euclid font-semibold text-base ">
            <router-link to="/add-reminder"> <button class="py-2 px-4 rounded-xl border-2 bg-medalertBlue border-medalertBlue text-white hover:bg-blueHover hover:text-white ">Add Reminder</button></router-link>
            </div>
    </div>

    <div class="flex justify-between w-full">

      <div class="flex flex-col w-4/6">

       
        <!-- Loader -->
        <div  class="flex justify-center content-center items-center align-middle w-full" v-if="isLoading">
          <Loader />
        </div>


        <!-- LATEST REMINDER -->
        <div class=" h-auto font-euclid">

          <!-- EMPTY STATE -->
          <div v-if="allReminders.length == 0" class=" flex flex-col bg-white px-20 py-52 w-full mt-10  rounded-md justify-center items-center text-center">
              <i class="ri-notification-off-line text-4xl text-gray-400"></i>
              <h1 class="text-gray-500">You have not created any <br>reminder yet</h1>
          </div>

          <ul v-if="!searchInput">
            <li v-for="(reminder,index) in allReminders" :key="index">
              <div class="bg-white rounded-sm h-auto  w-full mx-auto mt-8 ">
                <div class=" flex justify-between bg-gray-100 w-full py-1 px-6 align-middle content-center text-center items-center">
                  <div class="flex">
                    <h1 class=" text-medalertBlue my-auto font-medium mr-2">{{reminder.phone_number}}</h1> 
                    
                  </div>

                  <!-- <div class="text-sm text-center font-normal">
                    <h1>Created By: {{reminder.created_by}}</h1>
                  </div> -->

                  <div class="flex my-auto justify-between w-4/12">
                    <div class="tooltip">
                      <i class="ri-alarm-warning-line text-lg text-black"> <span class="font-euclid font-medium text-sm align-middle">{{reminder.total_number_of_reminder}}</span></i>
                      <span class="tooltiptext">Total SMS</span>
                    </div>

                    <div class="tooltip">
                      <i class="ri-check-double-fill text-lg text-medalertBlue   "><span class="font-euclid font-medium text-sm align-middle ">{{reminder.no_of_sent_reminder}}</span></i>
                    <span class="tooltiptext">Sent SMS</span>
                    </div>

                    <div class="tooltip">
                      <i class="ri-time-line text-lg text-medalertOrange "><span class="font-euclid font-medium text-sm align-middle">{{reminder.total_number_of_reminder - reminder.no_of_sent_reminder}}</span></i>
                      <span class="tooltiptext">Pending SMS</span>
                    </div>

                    <div  class="cursor-pointer"> 
                      <span class=" " v-if="!reminder.suspended" > <button class="disabled:bg-gray-300 bg-medalertOrange text-white hover:text-white hover:bg-redHover  rounded py-1 px-2 text-xs "
                        :disabled="reminder.total_number_of_reminder - reminder.no_of_sent_reminder ===0"
                        :class="reminder.total_number_of_reminder - reminder.no_of_sent_reminder ===0 ? 'cursor-not-allowed' : ''"
                         @click.prevent="stopReminder(reminder.id)"> Suspend </button></span> <span v-else class=""> <button class="disabled:bg-gray-300  bg-medalertBlue text-white hover:text-white  hover:bg-blueHover  rounded py-1 px-2 text-xs " @click.prevent="resumeReminder(reminder.id)"> Resume </button></span> 
                    </div>

                  </div>
                </div>

                <div class="py-2 px-6 text-left text-black text-sm tracking-wide">
                  <table class="table w-full text-left mx-auto rounded-md table-auto">
                    <thead class="bg-gray-200 py-2 font-light rounded-md">
                      <tr>
                      </tr>
                    </thead>
                      <tbody>
                        <tr v-for="(prescription, index) in reminder.items" :key="index">
                          <td>{{prescription.drug_name}}</td>
                          <td> <span v-if="prescription.dose">{{prescription.dose}}</span> <span v-else>None</span> </td>
                          <td>x {{prescription.no_of_days}} Days</td>
                          <td> Starting: {{ new Date(prescription.start_time).toLocaleDateString()}}</td>
                        </tr>
                        <tr class="">
                          <div class=" pt-3  text-xs font-normal bg-white">
                            <h1>Created By: {{reminder.created_by}}</h1>
                          </div>
                        </tr>
                      </tbody>
                  </table>
                </div>

              </div>
            </li>
          </ul>

          <ul v-if="searchedReminders && searchInput ">

            <div
                v-if="isSearching"
                class=" border w-full mx-auto mt-2 bg-medalertOrange border-medalertOrange text-white px-3 py-3 rounded relative"
                role="alert">
                    <strong class="font-bold mx-2">Sorry!</strong>
                    <span class="">No result found</span>
            </div>

            <li v-for="(reminder,index) in searchedReminders" :key="index">
              <div class="bg-white rounded-sm h-auto  w-full mx-auto mt-8 ">
                <div class=" flex justify-between bg-gray-100 w-full py-1 px-6 align-middle content-center text-center items-center">
                  <div class="flex">
                    <h1 class=" text-medalertBlue my-auto font-medium mr-2">{{reminder.phone_number}}</h1> 
                  </div>

                  <!-- <div class="text-sm text-center font-normal">
                    <h1>Created By: {{reminder.created_by}}</h1>
                  </div> -->

                  <div class="flex my-auto justify-between w-4/12">
                    <div class="tooltip">
                      <i class="ri-alarm-warning-line text-lg text-black"> <span class="font-euclid font-medium text-sm align-middle">{{reminder.total_number_of_reminder}}</span></i>
                      <span class="tooltiptext">Total SMS</span>
                    </div>

                    <div class="tooltip">
                      <i class="ri-check-double-fill text-lg text-medalertBlue   "><span class="font-euclid font-medium text-sm align-middle ">{{reminder.no_of_sent_reminder}}</span></i>
                    <span class="tooltiptext">Sent SMS</span>
                    </div>

                    <div class="tooltip">
                      <i class="ri-time-line text-lg text-medalertOrange "><span class="font-euclid font-medium text-sm align-middle">{{reminder.total_number_of_reminder - reminder.no_of_sent_reminder}}</span></i>
                      <span class="tooltiptext">Pending SMS</span>
                    </div>

                    <div  class="cursor-pointer"> 
                      <span class=" " v-if="!reminder.suspended" > <button class="disabled:bg-gray-300 bg-medalertOrange text-white hover:text-white hover:bg-redHover  rounded py-1 px-2 text-xs "
                        :disabled="reminder.total_number_of_reminder - reminder.no_of_sent_reminder ===0"
                        :class="reminder.total_number_of_reminder - reminder.no_of_sent_reminder ===0 ? 'cursor-not-allowed' : ''"
                         @click.prevent="stopReminder(reminder.id)"> Suspend </button></span> <span v-else class=""> <button class="disabled:bg-gray-300  bg-medalertBlue text-white hover:text-white  hover:bg-blueHover  rounded py-1 px-2 text-xs " @click.prevent="resumeReminder(reminder.id)"> Resume </button></span> 
                    </div>

                  </div>
                </div>

                <div class="py-2 px-6 text-left text-black text-sm tracking-wide">
                  <table class="table w-full text-left mx-auto rounded-md table-auto">
                    <thead class="bg-gray-200 py-2 font-light rounded-md">
                      <tr>
                      </tr>
                    </thead>
                      <tbody>
                        <tr v-for="(prescription, index) in reminder.items" :key="index">
                          <td>{{prescription.drug_name}}</td>
                          <td> <span v-if="prescription.dose">{{prescription.dose}}</span> <span v-else>None</span> </td>
                          <td>x {{prescription.no_of_days}} Days</td>
                          <td> Starting: {{ new Date(prescription.start_time).toLocaleDateString()}}</td>
                        </tr>
                        <tr class="">
                          <div class=" pt-3  text-xs font-normal bg-white">
                            <h1>Created By: {{reminder.created_by}}</h1>
                          </div>
                      </tr>
                      </tbody>
                  </table>
                </div>

              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- REMINDER STATISTIC -->
      <div class="flex flex-col w-2/6 pl-14 h-auto mt-8">
        <div class=" flex w-full  mx-auto  font-euclid">

          <div class="bg-white w-full flex flex-col   text-center py-4 px-6 rounded-lg">
            <span v-if="isLoading">
              <Loading />
            </span> 
            
            <div v-if="!isLoading" > 
              <p class="text-black font-medium text-base border-b-2">Reminder Metrics</p>
              <div class="my-5 text-black">
                <h1 class="  font-medium text-2xl "> {{totalReminders}}</h1> <span class="font-semibold">Total reminders</span>
              </div>
              <div class="my-5 text-medalertBlue ">
                <h1 class=" font-medium text-2xl ">{{sentReminders}}</h1> <span class="font-semibold">Sent Reminders</span>
              </div>
              <div class="my-5 text-medalertOrange">
                <h1 class=" font-medium text-2xl ">{{pendingReminders}}</h1> <span class="font-semibold">Pending Reminders</span>
              </div>
              <div class="my-5 text-black">
                <h1 class="  font-medium text-2xl ">{{uniqueCustomers}}</h1> <span class="font-semibold">Unique Clients</span>
              </div>
              <!-- <div class="my-5 text-black">
                <h1 class="text-black  font-medium text-2xl"> ₦ {{totalReminderCost}} </h1> <span class="font-semibold">Total Amount Due</span>
              </div> -->
              <div class="my-5 text-black">
                <h1 class="text-black  font-medium text-2xl">  {{user.units_remaining}} </h1> <span class="font-semibold">Total Units Remaining </span>
              </div>
            </div>
          

              
          </div>

        </div>
        

      </div>

    </div>

  </div>

  </div>

   <div v-if="allReminders.length != 0 && searchInput == ''"  class="mt-16">
    <vue-awesome-paginate
    :total-items="reminderCount"
    :items-per-page="limit"
    :max-pages-shown="5"
    :current-page="pageNumber"
    :on-click="onClickHandler"/> 
  </div>

   </div> 

</div>
</template>



<script>

import navBar from '../components/NavBar'
import sideBar from '../components/SideBar'
import axios from 'axios';
import Loader from "../components/Loader";
import Loading from "../components/Loading";

import { ref } from 'vue'
import {useRouter} from 'vue-router'
import { useStore } from "vuex";



export default {

  components:{navBar, sideBar, Loader, Loading},

  setup(){

    const router = useRouter()
    const store = useStore();
    const user = store.state.user
    const isLoading = ref(false);

    // const offSet = ref(1)
    // const pageNumber = ref(offSet.value - 1)
    // const calculatedPageNo =  ref(pageNumber.value + 1)
    const pageNumber = ref(1)
    const limit = ref(5)
    const reminderCount = ref(0)

    const onClickHandler = (page) => {
      pageNumber.value = page
      reminderRecords()
    console.log(page);
    };

    const verifyStatus = store.state.user.client.is_verified

    const success = ref("");
    const err = ref("");
    const searchInput = ref('');
    const isSearching = ref(false);

    const allReminders = ref([]);
    console.log(allReminders)

    const searchedReminders = ref([]);
    console.log(searchedReminders)


    const totalReminders = ref(null);
    const sentReminders = ref(null);
    const pendingReminders = ref(null);
    const totalReminderCost = ref(null);
    const uniqueCustomers = ref(null);

    const unverifyAlert = async () => {
      alert('Your account have not been verified. We will verify you soon')
    }


    const reminderRecords = async () =>{
      try{
        isLoading.value = true;
        const response = await axios.get(`/api/v1/prescriptions/approved?page-number=${pageNumber.value}&limit=${limit.value}`)
        let reminders = response.data.data.data
        console.log(reminders)
        console.log(response)
        allReminders.value = reminders

        // Getting reminder count
        const allReminderCount = response.data.data.total
        reminderCount.value = allReminderCount
        console.log(reminderCount.value)
        

        //Getting Total Reminder List
        // let totalReminderList = reminders.map(a => a.total_number_of_reminder)
        // console.log(totalReminderList)
        // const reminderSum = totalReminderList.reduce((accumulator, value) => {
        //   return accumulator + value;
        // }, 0);
        // totalReminders.value = reminderSum
        // console.log(reminderSum);

        //Getting Sent Reminder List
        // let sentReminderList = reminders.map(a => a.no_of_sent_reminder)
        // console.log(sentReminderList)
        // const sentReminderSum = sentReminderList.reduce((accumulator, value) => {
        //   return accumulator + value;
        // }, 0);
        // sentReminders.value = sentReminderSum
        // console.log(sentReminderSum);

        //Getting Pending Reminder List
        // let pendingReminderSum = reminderSum - sentReminderSum
        // pendingReminders.value = pendingReminderSum
        // console.log(pendingReminderSum);

         //Getting Total Amount Due
        // let totalAmoutDue = sentReminderSum * 5
        // totalReminderCost.value = totalAmoutDue
        // console.log(totalAmoutDue);
      
        isLoading.value = false;
      } catch(error){
        err.value = error.response?.data?.result?.message ?? "Erorr! could not fetch reminder record";
      }
    }
    

    const stopReminder = async (id) =>{
      try{
        const response = await axios.patch(`/api/v1/prescriptions/${id}/suspend`)
        if (response){
          // isSuspended.value = true
          let feedback =  response.data.result.message
          alert(feedback)
        } reminderRecords()
        searchReminder()

      } catch(error){
        err.value = error.response?.data?.result?.message ?? "Erorr! could not suspend reminder";
      }
    }

    const resumeReminder = async (id) =>{
      try{
        const response = await axios.patch(`/api/v1/prescriptions/${id}/resume`)
        if (response){
          let feedback =  response.data.result.message
          alert(feedback)
        } reminderRecords()
        searchReminder()
      } catch(error){
        err.value = error.response?.data?.result?.message ?? "Erorr! could not resume reminder";
      }
    }

    const searchReminder = async () =>{
      let filterInput = searchInput.value
      // isSearching.value = true
      try{
        if(verifyStatus){
          const response = await axios.get(`/api/v1/prescriptions/filter/${filterInput}`)
          if (response){
            let searchResult = response.data.data
            searchedReminders.value = searchResult
            if(searchInput.value != '' && searchResult.length == 0 ){
              isSearching.value = true
            } else{
              isSearching.value = false
              reminderRecords()
            }
            console.log(searchedReminders)
            console.log(searchResult)
          } 
        } else{
          alert('You are not verified')
          throw new Error('You are not verified')
        }
        
      } catch(error){
        err.value = error
      }
    }

    const clientMetrics = async()=>{
      try{
        const response = await axios.get('/api/v1/clients/metric')
        const getMetrics = response.data.data
        uniqueCustomers.value = getMetrics.unique_customers
        totalReminders.value = getMetrics.total_reminder
        sentReminders.value = getMetrics.total_reminder_sent
        pendingReminders.value = getMetrics.total_reminder_pending
        totalReminderCost.value = getMetrics.total_amount_due
        console.log(response)
      }catch(error){
        console.log(error)
      }
    }

    



    return{
        user,
        success,
        err,
        allReminders,
        verifyStatus,
        isLoading,
        sentReminders,
        pendingReminders,
        totalReminders,
        totalReminderCost,
        uniqueCustomers,
        reminderRecords,
        stopReminder,
        resumeReminder,
        unverifyAlert,
        clientMetrics,
        searchInput,
        searchedReminders,
        searchReminder,
        isSearching,
        onClickHandler,
        reminderCount,
        limit,
        // offSet,
        pageNumber,
        // calculatedPageNo
        
      }

  },

  mounted(){
      this.reminderRecords();
      this.clientMetrics();
      // this.searchReminder();
    }

 

}
</script>





<style>
  .pagination-container {
    display: flex;
    column-gap: 10px;
  }
  .paginate-buttons {
    height: 34px;
    width: 34px;
    border-radius: 20px;
    cursor: pointer;
    background-color: rgb(242, 242, 242);
    border: 1px solid rgb(217, 217, 217);
    color: black;
  }
  .paginate-buttons:hover {
    background-color: #FFA400;
    border: 1px solid #FFA400;
    color: white;
  }
  .active-page {
    background-color: #220DFF;
    border: 1px solid #220DFF;
    color: white;
  }
  .active-page:hover {
    background-color: #FFA400;
    border: 1px solid #FFA400;
  }


  .tooltip {
  position: relative;
  display: inline-block;
  opacity: 2;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 80px;
  background-color: #DCD0FF;
  opacity: 2;
  color: black;
  text-align: center;
  border-radius: 2px;
  padding: 2px 0px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  font-size: small;
}

</style>